import { render, staticRenderFns } from "./Showactorderdetail.vue?vue&type=template&id=ade54266&"
import script from "./Showactorderdetail.vue?vue&type=script&lang=js&"
export * from "./Showactorderdetail.vue?vue&type=script&lang=js&"
import style0 from "./Showactorderdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports